// Menção em comentário de card: o texto guarda "@Nome" e os ids vão à parte
// (mentioned_user_ids), conferidos no servidor.

export const mentionQueryAt = (text, caret) => {
  const match = text.slice(0, caret).match(/(?:^|\s)@([^\s@]*)$/);
  return match ? match[1] : null;
};

export const insertMention = (text, caret, name) => {
  const start = text.slice(0, caret).lastIndexOf('@');
  const inserted = `@${name} `;
  return {
    text: text.slice(0, start) + inserted + text.slice(caret),
    caret: start + inserted.length,
  };
};

const escapeRegExp = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Menção só conta no começo de palavra e fora de outro nome ("@Anabela" não é "@Ana").
const mentionBoundary = name =>
  `(?<![\\p{L}\\p{N}])@${escapeRegExp(name)}(?![\\p{L}\\p{N}])`;

// Nomes mais longos primeiro; o trecho "@Nome" que casou sai da cópia de trabalho, para
// "@Ana Souza" não contar também como "@Ana".
export const mentionedIds = (text, agents) => {
  let remaining = text;
  const ids = [];
  [...agents]
    .sort((a, b) => b.name.length - a.name.length)
    .forEach(agent => {
      const pattern = new RegExp(mentionBoundary(agent.name), 'u');
      if (!pattern.test(remaining)) return;
      ids.push(agent.id);
      remaining = remaining.replace(
        new RegExp(mentionBoundary(agent.name), 'gu'),
        ' '
      );
    });
  return agents.filter(agent => ids.includes(agent.id)).map(a => a.id);
};

export const filterAgents = (agents, query) => {
  const needle = query.toLowerCase();
  return agents
    .filter(agent => agent.name.toLowerCase().includes(needle))
    .slice(0, 6);
};

export const splitMentions = (text, names) => {
  if (!names.length) return [{ text, mention: false }];
  // Nomes mais longos primeiro: "@Ana Souza" ganha de "@Ana".
  const tokens = names
    .map(name => `@${name}`)
    .sort((a, b) => b.length - a.length);
  const alternation = names
    .map(name => mentionBoundary(name))
    .sort((a, b) => b.length - a.length)
    .join('|');
  const pattern = new RegExp(`(${alternation})`, 'u');
  return text
    .split(pattern)
    .filter(Boolean)
    .map(part => ({ text: part, mention: tokens.includes(part) }));
};
